import { Link } from 'react-router-dom';

export type ShortcutTone = 'blue' | 'green' | 'violet' | 'amber' | 'teal' | 'pink' | 'slate';

export interface CustomerShortcut {
  readonly id: string;
  readonly label: string;
  readonly tone: ShortcutTone;
  /** In-app route (router link). */
  readonly to?: string;
  /** External scheme such as `tel:`. */
  readonly href?: string;
  /** In-page action, e.g. switching tab. */
  readonly onClick?: () => void;
}

/**
 * Quick actions for ONE customer, shown inside the customer's own file. The list is built by the
 * page from what the server says this user may do (`actions`) and from the contact fields the
 * user may see, so a shortcut is present only when its target is usable — the target page still
 * enforces its own permission.
 */
export function CustomerShortcuts({ items }: { readonly items: readonly CustomerShortcut[] }) {
  if (items.length === 0) return null;
  return (
    <nav className="c360-shortcuts" aria-label="میانبرهای این مشتری">
      {items.map((item) =>
        item.to ? (
          <Link key={item.id} to={item.to} className="c360-shortcut" data-tone={item.tone}>
            {item.label}
          </Link>
        ) : item.href ? (
          <a key={item.id} href={item.href} className="c360-shortcut" data-tone={item.tone}>
            {item.label}
          </a>
        ) : (
          <button
            key={item.id}
            type="button"
            className="c360-shortcut"
            data-tone={item.tone}
            onClick={item.onClick}
          >
            {item.label}
          </button>
        ),
      )}
    </nav>
  );
}
